export enum EDateLabels {
  DD_MM_YYYY = 'DD/MM/YYYY',
}

export enum EDateFormats {
  dd_MM_yyyy = 'dd/MM/yyyy',
  'dd-MM-yyyy' = 'dd-MM-yyyy',

  MM_yyyy = 'MM/yyyy',
  'MM-yyyy' = 'MM-yyyy',

  yyyy_MM_dd = 'yyyy/MM/dd',
  'yyyy-MM-dd' = 'yyyy-MM-dd',

  yyyy_dd_MM = 'yyyy/dd/MM',
  'yyyy-dd-MM' = 'yyyy-dd-MM',

  yyyy_MM_dd_HH_mm_ss = "yyyy-MM-dd'T'HH:mm:ss'Z'",
  yy = 'yy',
  yyyy = 'yyyy',
}
